import BossModel from "@/models/BossModel";
import ChargeType from "@/models/ChargeType/ChargeType";
import Currency from "@/models/Currency/Currency";
import Type from "@/models/Product/Allowance/Type/Type";
import Product from "@/models/Product/Product";
import Composition from "@/models/Product/Detail/Composition/Composition";
import AllowanceProductDetailComposition from "@/models/Product/Allowance/AllowanceProductDetailComposition";
import Day from "@/models/Product/Allowance/Day/Day";

export default class Allowance extends BossModel {

    static apiUrl = 'product/allowance';

    static entity = 'productAllowances';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_price_extension_element_id: this.number(null).nullable(),
            apply_to_purchase: this.number(null),
            currency_id: this.number(null),
            product_id: this.number(null),
            product_allowance_type_id: this.number(null),
            charge_type_id: this.number(null),
            charge_unit_id: this.number(null),
            is_visible_to_customer: this.number(null),
            apply_to_sale: this.number(null),
            start: this.number(null),
            start_date_at: this.attr(null),
            end_date_at: this.attr(null),
            adult: this.number(null),
            child: this.number(null),
            baby: this.number(null),
            single_amount: this.number(null),
            note: this.string(null).nullable(),
            sort_order: this.number(null),
            is_active: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            chargeType: this.belongsTo(ChargeType, 'charge_type_id'),
            type: this.belongsTo(ChargeType, 'charge_type_id'),
            allowanceType: this.belongsTo(Type, 'product_allowance_type_id'),
            currency: this.belongsTo(Currency, 'currency_id'),
            product: this.belongsTo(Product, 'product_id'),
            pax: this.belongsToMany(Composition,AllowanceProductDetailComposition, 'product_allowance_id', 'product_detail_composition_id'),
            days: this.hasMany(Day, 'product_allowance_id'),
        }
    }
}
